import * as React from "react";
import { Box, Flex, Link, Stack, Text } from "@chakra-ui/react";
import { Reservation } from "../../types";
import dayjs from "dayjs";

type Props = {
  reservation: Reservation;
  onClick: (reservation: Reservation) => void;
};

export const ReservationCard: React.FC<Props> = ({ reservation, onClick }) => {
  return (
    <Box
      w={"100%"}
      p="4"
      border="1px"
      borderColor="#EBF3F8"
      borderRadius="16px"
      mt={"20px"}
      mb={"20px"}
      boxShadow=" 0px 0px 20px rgba(51, 102, 255, 0.15)"
      cursor="pointer"
      onClick={() => onClick(reservation)}
    >
      <Flex>
        <Stack alignItems="center">
          <Text fontSize={"2xl"}>
            {reservation.source === "calendly"
              ? dayjs(reservation.eventMeta?.start_time).format("DD")
              : ""}
          </Text>
          <Text fontSize={"small"} marginTop={"0 !important"}>
            {reservation.source === "calendly"
              ? dayjs(reservation.eventMeta?.start_time).format("MMM YY")
              : ""}
          </Text>
        </Stack>
        <Stack>
          <Text fontSize="md" alignSelf="center" ml="20px">
            {reservation.source === "calendly"
              ? reservation.eventMeta?.name
              : ""}
          </Text>
          <Text fontSize="sm" alignSelf="center" ml="20px">
            {reservation.source === "calendly"
              ? "Ore " +
                dayjs(reservation.eventMeta?.start_time).format("HH:mm")
              : ""}
          </Text>
        </Stack>
      </Flex>
    </Box>
  );
};
